import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { MutationTree } from "vuex";
import { FETCH_DEVICE_TREE } from "./actions";
import { DevicesState } from "./state";

export const SET_DEVICE_TREE = "SET_DEVICE_TREE";
export const SET_DEVICE_TREE_CONTENT = "SET_DEVICE_TREE_CONTENT";
export const RESET_DEVICE_TREE = "RESET_DEVICE_TREE";

export default {
    [SET_DEVICE_TREE_CONTENT](state, { node, content }) {
        if (node != null) {
            let checkTreeNode = (d) => {
                if (d.id == node && d.type == DeviceTreeNodeTypeEnum.Folder) d.children = content;
                else if (d.children) d.children.forEach(checkTreeNode);
            };
            state.deviceTree.forEach(checkTreeNode);
        } else {
            state.deviceTree = content;
        }
    },
    [SET_DEVICE_TREE](state, { parent, content }) {
        if (parent != null) {
            let checkNode = (d) => {
                if (d.Id == parent) d.children.push(...content);
                else if (d.children) d.children.forEach(checkNode);
            };
            state.deviceTree.forEach(checkNode);
        } else {
            state.deviceTree = content;
        }
    },
    [RESET_DEVICE_TREE]() {
        console.log("m.RESET_DEVICE_TREE");
        this.commit(SET_DEVICE_TREE_CONTENT, { node: null, content: [] }); // deviceTree = []
        this.dispatch(FETCH_DEVICE_TREE);
    },
} as MutationTree<DevicesState>;
